export default __webpack_public_path__ + "static/media/imgLightEn8.8b2703e1.png";